module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerbar",
    class: {
      'no-mall': _vm.isSwan
    },
    staticStyle: {
      "display": "none"
    }
  }, [_c('router-link', {
    staticClass: "item",
    class: {
      current: _vm.current == 1
    },
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    ref: "hotIcon",
    staticClass: "hot-icon"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    class: {
      current: _vm.current == 2
    },
    attrs: {
      "to": "/consultIndex"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getLog('1531189023')
      }
    }
  }, [_c('i', {
    ref: "askIcon",
    staticClass: "ask-icon"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    class: {
      current: _vm.current == 3
    },
    attrs: {
      "to": "/MeMessages?type=1"
    }
  }, [_c('i', {
    ref: "messageIcon",
    staticClass: "message-icon"
  }), _vm._v(" "), (_vm.messageCount) ? _c('div', {
    staticClass: "count-dot"
  }, [_vm._v(_vm._s(_vm.messageCount) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    class: {
      current: _vm.current == 4
    },
    attrs: {
      "to": "/meIndex"
    }
  }, [_c('i', {
    ref: "presonalIcon",
    staticClass: "presonal-icon"
  }), _vm._v(" "), (_vm.isShowNoReadMsg) ? _c('span', {
    staticClass: "unread-messages"
  }) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20b48621", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20b48621","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/footer.vue
// module id = 412
// module chunks = 32